import cronstrue from 'cronstrue';
import type { FC } from 'react';
import { useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { buildCronExpression } from './cronBuilder';
import {
  DaysField,
  HourField,
  MinuteField,
  MonthsField,
  TimezoneInlineField,
  WeekDaysField,
} from './cronFields';
import type { CronFormData } from './cronTypes';
import { cronFormSchema } from './cronValidation';

type CronCustomFieldsProps = {
  disabled?: boolean;
};

export const CronCustomFields: FC<CronCustomFieldsProps> = ({
  disabled = false,
}) => {
  const { control } = useFormContext<CronFormData>();
  const formValues = useWatch({ control });

  const humanReadableExpression = useMemo(() => {
    if (!formValues) {
      return null;
    }

    const result = cronFormSchema.safeParse(formValues);
    if (!result.success) {
      return null;
    }

    try {
      const expression = buildCronExpression(result.data);
      return cronstrue.toString(expression);
    } catch {
      return null;
    }
  }, [formValues]);
  return (
    <div className='flex flex-col gap-1'>
      <div className='flex items-center h-8'>
        <span className='text-sm'>
          set custom schedule using the cron syntax
        </span>
      </div>
      <div className='flex items-start gap-4'>
        <MinuteField disabled={disabled} />
        <HourField disabled={disabled} />
        <DaysField everyValue='custom' disabled={disabled} />
        <MonthsField everyValue='custom' disabled={disabled} />
        <WeekDaysField everyValue='custom' disabled={disabled} />
      </div>
      <div className='flex-none mt-1'>
        <TimezoneInlineField disabled={disabled} />
      </div>
      <div className='text-sm mt-1 text-status-disabled-dark'>
        {humanReadableExpression}
      </div>
    </div>
  );
};
